module.exports = __webpack_public_path__ + "static/group-image3-440d278a6075a388a3b5eb57fbcf47c3.jpg";